import PayoutToken from '@apps/maha/admin/tokens/payout'
import StatusToken from '@admin/tokens/status'
import Panel from '@admin/components/panel'
import Issue from './issue'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Payouts)',
  collection: {
    endpoint: '/api/admin/truevail/admin/payouts',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Payout)', key: 'date', format: (payout) => (
        <PayoutToken payout={ payout } />
      ) },
      { label: 't(Affiliate)', key: 'affiliate.team.title', primary: true },
      { label: 't(Payments)', key: 'payments_count', collapsing: true, align: 'right' },
      { label: 't(Commision)', key: 'total', collapsing: true, align: 'right', format: 'currency' },
      { label: 't(Status)', key: 'status', collapsing: true, format: StatusToken }
    ],
    empty: {
      title: 't(No Payouts)',
      text: 't(There are no payouts for this affiliate)',
      svg: 'hand_coins'
    },
    entity: 'team',
    defaultSort: { key: 'created_at', order: 'desc' },
    recordTasks: (record) => [
      {
        label: 't(Issue Payout)',
        svg: 'hand_coins',
        show: ['pending','failed'].includes(record.status),
        request: {
          endpoint: `/api/admin/truevail/admin/payouts/${record.id}/issue`,
          method: 'PATCH'
        }
      }
    ],
    onClick: (record) => context.router.push(`/admin/truevail/admin/payouts/${record.id}`)
  },
  tasks: {
    items: [
      {
        label: 't(Generate Payouts)',
        svg: 'cog',
        request: {
          endpoint: '/api/admin/truevail/admin/payouts/generate',
          method: 'POST',
          onSuccess: () => {},
          onFailure: () => {}
        }
      },
      {
        label: 't(Issue Payouts)',
        svg: 'hand_coins',
        modal: <Issue />
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
